<template>
  <article>
    <header class="view__header">
      <h2 class="view__title">{{ L.localize('Campaigns_Breadcrumb_Index') }}</h2>
    </header>

    <list
      class="view__content"
      :data="entries()"
      :fields="headers()"
      :hideCreate="false"

      @action="action" />
  </article>
</template>

<script>
import List from 'components/layout/list'
import L from 'services/Localization'
import { mapGetters } from 'vuex'
import listHelpers from 'mixins/list-helpers'

export default {
  name: 'campaigns',
  components: { List },
  mixins: [ listHelpers ],
  beforeCreate() {
    this.$store.dispatch('getAllCampaigns')
  },
  data() {
    return {
      L: L
    }
  },
  computed: {
    ...mapGetters({
      campaigns: 'allCampaigns',
      pagination: 'allCampaignsPagination'
    })
  },
  methods: {
    headers: function() {
      let headers = [
        { prop: 'name', label: L.localize('Label_Name') },
        { prop: 'createdAt', label: L.localize('Label_CreationDate'), transform: this.showDateTimeFromEpoch },
        { prop: 'sentAt', label: L.localize('Label_SentDate'), transform: this.showDateTimeFromEpoch },
        { prop: 'status', label: L.localize('Label_Status') }
      ]
      return headers
    },
    entries: function() {
      return this.campaigns
    },
    action(command) {
      switch (command.name) {
        case 'detail':
          this.$router.push({name: 'campaign', params: { id: command.item.id }})
          break;
        case 'create':
          this.$router.push({name: 'campaign-create'})
          break;
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Campaigns.vue?9ee901ac